export default __webpack_public_path__ + "static/media/login-check.49a3daae.gif";